export default "/images/youtube_footer_logo.png";